import { Button } from '@ondit/ui'
import { ArrowLeft } from '@ondit/ui/icons'
import { useNavigate, useParams } from 'react-router'
import { type ErrorBoundaryProps, ErrorState } from '@/screens/workspace/components'
import { useT } from '~/core/i18n'

export default function TableError({ error, reset }: ErrorBoundaryProps) {
  const t = useT()
  const navigate = useNavigate()
  const { workspaceId } = useParams() as { workspaceId: string }

  return (
    <ErrorState
      error={error}
      reset={reset}
      title={t('Failed to load table')}
      description={t(
        'Something went wrong while loading this table. The table may have been deleted or you may not have permission to view it.'
      )}
      loggerName='TableError'
    >
      <Button
        variant='default'
        size='md'
        onClick={() => navigate(`/w/${workspaceId}/agent/tables`)}
      >
        <ArrowLeft className='mr-1.5 size-[14px]' />
        {t('Go back')}
      </Button>
    </ErrorState>
  )
}
